/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Studienbescheinigungsids2Inputs */



/**

* @param {_Field_Studienbescheinigungsids2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_studienbescheinigungsids2 = /** @type {((inputs?: _Field_Studienbescheinigungsids2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Studienbescheinigungsids2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Studienbescheinigungen")
});
export { _field_studienbescheinigungsids2 as "_field_studienbescheinigungsIDs" }